import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { AuthService } from '../../../../commons/services/auth.service';
import { AppModule } from '../../../../app-module';
import { v4 as uuidv4 } from 'uuid';
import { ModalIframeService } from '../../../../commons/components/modal-iframe/modal-iframe.service';
import { Documents } from '../../../../commons/class/archivo.inteface';
import { ElectronicDemandService } from '../../../demanda/electronicDemand.service';
import { AlertService } from '../../../../commons/components/alert/alert.service';
import { AlertComponent } from "../../../../commons/components/alert/alert.component";
import { Router } from '@angular/router';
import { ENV_TOKEN } from '../../../../app-module.token';
import { FirmadorAvisoPrivacidadService } from '../../../../commons/shared/firmador-aviso-privacidad.service';

@Component({
  selector: 'oaj-documento-component',
  imports: [AppModule, AlertComponent],
  templateUrl: './documento-component.html',
  styleUrl: './documento-component.css',
  providers: [AuthService, ModalIframeService, ElectronicDemandService, AlertService]
})
export class DocumentoComponent {
  loading = false;
  reiniciando = false;
  chkAviPriv = false;
  chkTerCon = false;
  private constService: any;
  uuid = "0";
  public lstDocumentos: any[] = [];
  isLoadingFile = false;
  sMensajeLoad = "Consultando archivos...";
  private authService: AuthService = inject(AuthService);
  private modalIframeService: ModalIframeService = inject(ModalIframeService);
  private _service: ElectronicDemandService = inject(ElectronicDemandService);
  private alertService: AlertService = inject(AlertService);
  private router: Router = inject(Router);
  readonly environment = inject(ENV_TOKEN);
  private firmador = inject(FirmadorAvisoPrivacidadService);
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    this.constService = this.environment;
  }

  /**
   * Funcion para cerrar la sesión del usuario, se llama a la función logout del servicio de autenticación para eliminar la información de autenticación del usuario y redirigirlo a la página de login
   */
  logout() {
    this.authService.logout();
  }

  /**
   * Funcion para cargar el documento de términos y condiciones, se genera una url para la firma del documento utilizando la información del usuario autenticado y la configuración del sistema, se abre una modal con un iframe para mostrar la url de firma, al cerrar la modal se consulta el servicio para obtener los documentos relacionados a la pantalla de términos y condiciones utilizando el uuid generado, si se obtiene información se asigna a la propiedad lstDocumentos y se redirige a la página de cambio de contraseña inicial, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
   */
  cargaArchivo(): void {

    const IdPantalla = 0;
    const TipoArchivo = this.constService.TipoDoctos.TerminosyCondiciones;
    //let FirmaObligatoria = 1;
    const DocumentoDeTerminos = this.constService.idDocumentoTerminoyCondiciones;
    /* const PermisoNoFirma = this.authService.getbPermisoNoFirma();
 
     if (PermisoNoFirma) {
       FirmaObligatoria = 0;
     }
     else {
       FirmaObligatoria = 1;
     }*/
    if (this.uuid == "0") {
      this.uuid = uuidv4();
    }

    const urlFirma = `${this.constService.baseUrlFirmaPrecargaDocumento}?userName=${this.authService.getUserName()}&idUser=${this.authService.getIdUser()}&idOrganismo=${this.authService.getIdOrganoAux()}&IdSystem=1&IdPantalla=${IdPantalla}&IdTransaction=${this.uuid}&tipoArchivo=${TipoArchivo}&mma=1&arrayTick=${this.authService.getIdAutoEnrolamiento()}|${DocumentoDeTerminos}`;

    this.modalIframeService.open('Firma de documentos',
      urlFirma,
      'Cerrar',
      'xl').then((closed) => {
        if (closed) {
          this.GetDocumentosPantalla(this.uuid).then((resolve) => {
            this.lstDocumentos = resolve;
            if (this.lstDocumentos.length > 0) {
              this.router.navigate(['/ChangePassIni']);
            }

          });
        }
      }).catch(() => console.error('Ocurrio un error con la modal de iframe'));
  }

  /**
   * Funcion para obtener la lista de documentos relacionados a la pantalla de términos y condiciones, se hace una consulta al servicio para obtener los documentos dependiendo del uuid proporcionado, si se obtiene la informacion se asigna a la propiedad lstDocumentos para mostrarla en la vista, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
   * @param uuid 
   * @returns 
   */
  public GetDocumentosPantalla(uuid: string): Promise<Documents[]> {

    return new Promise((resolve) => {
      this.isLoadingFile = true;
      this._service.getDocumentosPantallaGuid(uuid)
        .subscribe((response: Documents[]) => {
          if (response?.length > 0) {
            this.isLoadingFile = false;

            resolve(response);
          }
          else {
            this.isLoadingFile = false;
            resolve([]);
          }
        }, (error: any) => {
          this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
          this.isLoadingFile = false;
          resolve([]);
        });

    });
  }

 async openWindowFirma(): Promise<void> {
  if (this.uuid === "0") {
    this.uuid = uuidv4();
  }
  this.loading = true;
  this.isLoadingFile = true;
  
  // Detectar cuando ya no existe el bloqueador (ventana abierta)
  const checkWindowOpened = setInterval(() => {
    const blocker = document.querySelector('.blocker-overlay'); // Ajusta el selector según tu implementación
    if (blocker) {
      this.loading = false;  
       this.changeDetectorRef.detectChanges();    
      clearInterval(checkWindowOpened);
     
    }
  }, 100);
  
  try {
    const signCompletedData = await this.firmador.openWindowFirma(
      this.uuid, 
      this.constService.TipoDoctos.TerminosyCondiciones
    );
    
    clearInterval(checkWindowOpened);
    
    if (signCompletedData.length > 0) {
      this.router.navigate(['/ChangePassIni']);
    }
  } finally {
    this.isLoadingFile = false;
    this.loading = false;
    this.changeDetectorRef.detectChanges();
  }
}
}
